import { render, staticRenderFns } from "./AddArticleExisting.vue?vue&type=template&id=cba5f68c&scoped=true"
import script from "./AddArticleExisting.vue?vue&type=script&lang=js"
export * from "./AddArticleExisting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba5f68c",
  null
  
)

export default component.exports